import * as API from '../api'

export const FETCHING_NEWS = 'FETCHING_NEWS'
export const FETCH_NEWS = 'FETCH_NEWS'
export const FETCH_NEWS_ERROR = 'FETCH_NEWS_ERROR'

export const fetchNews= (areaId) => {
  return dispatch => {
    dispatch({
      type: FETCHING_NEWS,
      value: true
    })

    return API.news
      .getNews(areaId)
      .then(response => {
        const { data = [] } = response
        dispatch({
          type: FETCH_NEWS,
          data,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_NEWS_ERROR
        })
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/news.js